import React from 'react'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'

import FooterConditions from './FooterConditions'
import FooterPerks from './FooterPerks'

interface ReferralProgramFooterProps {
  isoCountryCode: string
}

const ReferralProgramFooter: React.FC<ReferralProgramFooterProps> = ({ isoCountryCode }) => {
  const { isMobile } = useBreakpoint()

  return (
    <>
      <Box
        flexDirection={isMobile ? 'column' : 'row'}
        gap="s32"
        width="full"
        minHeight="s300"
        paddingTop={isMobile ? 's0' : 's32'}
        paddingBottom="s80"
        justifyContent="center"
      >
        <Box
          flexDirection={isMobile ? 'column' : 'row'}
          style={{
            maxWidth: '1200px',
          }}
          width="full"
          gap="s32"
        >
          <FooterConditions isMobile={isMobile} />
          <FooterPerks isoCountryCode={isoCountryCode} />
        </Box>
      </Box>
    </>
  )
}

export default ReferralProgramFooter
